/**
 * @generated SignedSource<<2e621697ba5687fc51f59285dce831b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookScrapsClassificationInput = {
  book: string;
  bookScraps?: ReadonlyArray<string> | null;
  refillTex?: boolean | null;
};
export type BookBookScrapsClassificationDialog_bookScrapsClassificationMutation$variables = {
  input: BookScrapsClassificationInput;
};
export type BookBookScrapsClassificationDialog_bookScrapsClassificationMutation$data = {
  readonly bookScrapsClassification: {
    readonly id: string;
    readonly unclassifiedBookScrapCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"BookActionsMutationButtonStack_book">;
  };
};
export type BookBookScrapsClassificationDialog_bookScrapsClassificationMutation = {
  response: BookBookScrapsClassificationDialog_bookScrapsClassificationMutation$data;
  variables: BookBookScrapsClassificationDialog_bookScrapsClassificationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unclassifiedBookScrapCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookBookScrapsClassificationDialog_bookScrapsClassificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Book",
        "kind": "LinkedField",
        "name": "bookScrapsClassification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookActionsMutationButtonStack_book"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookBookScrapsClassificationDialog_bookScrapsClassificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Book",
        "kind": "LinkedField",
        "name": "bookScrapsClassification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actions",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf699442c70802738a95ed9dd4f794e9",
    "id": null,
    "metadata": {},
    "name": "BookBookScrapsClassificationDialog_bookScrapsClassificationMutation",
    "operationKind": "mutation",
    "text": "mutation BookBookScrapsClassificationDialog_bookScrapsClassificationMutation(\n  $input: BookScrapsClassificationInput!\n) {\n  bookScrapsClassification(input: $input) {\n    id\n    unclassifiedBookScrapCount\n    ...BookActionsMutationButtonStack_book\n  }\n}\n\nfragment BookActionsMutationButtonStack_book on Book {\n  id\n  actions\n}\n"
  }
};
})();

(node as any).hash = "4134a4d09bb42b4d2e713fd6ac32cc26";

export default node;
